export default function Cross({ fill, h, w }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      fill="none"
      viewBox="0 0 8 8"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M7.073 7.84a.543.543 0 10.768-.767L4.768 4 7.841.927A.543.543 0 007.073.16L4 3.232.927.159A.543.543 0 10.16.927L3.232 4 .159 7.073a.543.543 0 00.768.768L4 4.768l3.073 3.073z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
